module.exports = __webpack_public_path__ + "static/img/home_bg2.b57a474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_bg2.png
// module id = VBEZ
// module chunks = 3